module.exports = "/fonts/fa-brands-400.woff?ec3cfddedb8bebd2d7a3fdf511f7c1cc";